import React from 'react'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import Group from 'components/utils/Group'
import { EmptyArray } from 'lib/array/arrayUtils'
import MultiRoomOfferBookButton from 'components/OfferPage/MultipleRoomsBooking/MultiRoomOfferBookButton'
import { hasDifferentPackagesForRooms } from 'selectors/offerPage/multipleRoomBookingSelectors'
import styled from 'styled-components'
import { rem } from 'polished'
import MultiRoomOfferAddToCartButton from 'components/OfferPage/MultipleRoomsBooking/MultiRoomOfferAddToCartButton'
import SoftOfferPageWalledGarden from 'components/Common/SoftOfferPageWalledGarden'
import { isMultiCartEnabled } from 'selectors/featuresSelectors'
import FlashHotelAvailabilityButton from '../FlashHotel/FlashHotelMobileVariant/FlashHotelAvailabilityButton'
import OfferPageStickyFooter from '../OfferPageStickyFooter'
import { isAvailableForPurchase } from 'selectors/offerPage/offerPageSelectors'

const StyledOfferPageStickyFooter = styled(OfferPageStickyFooter)`
  padding: ${rem(12)} ${rem(20)};
`
interface Props {
  offer: App.Offer;
  rooms?: Array<App.RoomOccupants>;
  checkInDate?: string;
  hasMultiRoomDifferentPackages?: boolean;
  userMultiItemCartEnabled: boolean;
  availableForPurchase?: boolean;
}

function AccommodationOfferPageStickyFooter(props: Props) {
  const {
    rooms = EmptyArray,
    checkInDate,
    offer,
    hasMultiRoomDifferentPackages,
    userMultiItemCartEnabled,
    availableForPurchase,
  } = props

  const canBook = !!(checkInDate && rooms && availableForPurchase)
  const canBookNowMultiRoom = rooms.length > 1 && canBook && hasMultiRoomDifferentPackages

  return (
    <StyledOfferPageStickyFooter
      visible
      callToActionDisabled
      offer={offer}
    >
      <SoftOfferPageWalledGarden>
        {canBookNowMultiRoom && <Group direction="horizontal" gap={8} horizontalAlign="stretch" fullWidth>
          {userMultiItemCartEnabled && <MultiRoomOfferAddToCartButton size="large" fit="flex" />}
          <MultiRoomOfferBookButton size="large" fit="flex" />
        </Group>}
        {!canBookNowMultiRoom && <FlashHotelAvailabilityButton size="large" fit="full-width"/>}
      </SoftOfferPageWalledGarden>
    </StyledOfferPageStickyFooter>
  )
}

export default withOfferPageAndReduxState((state, appState) => ({
  hasMultiRoomDifferentPackages: hasDifferentPackagesForRooms(state, appState),
  offer: state.offer,
  rooms: state.rooms,
  checkInDate: state.checkInDate,
  userMultiItemCartEnabled: isMultiCartEnabled(appState),
  availableForPurchase: isAvailableForPurchase(state, appState),
}), AccommodationOfferPageStickyFooter)
